module.exports = __webpack_public_path__ + "img/share.923322cc.svg";